<template>
<b-card title="Track Survey Member">
  <b-form-group label="Questionnaire link">
    <b-form-input v-model="link" />
  </b-form-group>
  <b-form-group label="Show log level">
    <b-form-select
      v-model="loglevel"
      :options="loglevels"
    />
  </b-form-group>  
  <b-button @click.prevent="getlog">Get tracking</b-button>
  <b-table
    id="tracking"
    hover
    :items="records"
    :fields="fields"
  >
  </b-table>
</b-card>
</template>
<script>
import axios from 'axios'
import { config } from '../../config';
const base_url = config.base_url;
const api_token = config.api_token;

const loglevels = [
  { value: 1, text: 'Summary'},
  { value: 5, text: 'Details'},
];

const fields = [
  { key: "access_date", label: "Date", sortable: true },
  { key: "operation", label: "Operation", sortable: false },
  { key: "browser", label: "Browser", sortable: false },
];

export default {
  name: 'TrackSurveyMember',
  data: function() {
    return {
      link: '',
      records: [],
      fields: fields,
      loglevel: 1,  
      loglevels: loglevels,    
    }
  },
  methods: {
    async getlog() {
      this.records = [];
      const filter = {
        url: {
          operator: '=',
          value: this.link,
        },
        loglevel: {
          operator: '<=',
          value: this.loglevel,
        }
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      const url = base_url+"/g_accesslog?"
                + 'orderby=access_date'
                + '&order=DESC' 
                +'&filter='+JSON.stringify(filter)
      axios.get(
        url,
        {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
      )
      .then(async(resp) => {
        for (const e of resp.data.result){
          // let thisbrowser = await this.getinformation(e.user_agent);
          const row =  {
            access_date: e.access_date,
            operation: e.operation,
            browser: e.user_agent, //thisbrowser,
          }
          this.records.push(row);
        }
      });
    },
    async getinformation(b) {
      const data = {
        b: b,
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return await axios.post(
        'https://api.eventerex.com/gdq/gdq_getbrowser.php',
        JSON.stringify(data), {
          headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
          }
        }
      )
      .then((resp) => {
        return resp.data.device_type+' '+resp.data.platform+' '+resp.data.browser+' '+resp.data.version;
      })          
    },
  }
  
}
</script>
<style scoped>

</style>